import React from "react";
import type { CheckboxProps } from "@material-ui/core/Checkbox";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

import type { CoretexTheme } from "../theme";

const useStyles = makeStyles((theme: CoretexTheme) => ({
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    borderRadius: 2,
    width: 14,
    height: 14,
    boxShadow: "inset 0 0 0 1px #D8D8D8",
    backgroundColor: "transparent",
    "$root.Mui-focusVisible &": {
      outline: "1px solid #D8D8D8",
      outlineOffset: 1,
    },
    // "input:hover ~ &": {
    // },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: theme.palette.mono.gray,
    },
  },
  checkedIcon: {
    backgroundColor: theme.palette.colour.primaryBlue,
    position: "relative",
    boxShadow: "0 0",
    "&:before": {
      display: "block",
      position: "absolute",
      top: "4px",
      left: "3px",
      width: 14,
      height: 14,
      backgroundRepeat: "no-repeat",
      backgroundImage:
        "url(\"data:image/svg+xml,%3Csvg width='8' height='6' viewBox='0 0 24 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M23.4979 0.479975C24.1674 1.11994 24.1674 2.15753 23.4979 2.7975L8.64065 17L0.575394 10.1468C-0.132233 9.54554 -0.195971 8.50974 0.433031 7.8333C1.06203 7.15685 2.14558 7.09592 2.85321 7.69721L8.50223 12.4973L21.0735 0.479975C21.743 -0.159992 22.8284 -0.159992 23.4979 0.479975Z' fill='%23FFFFFF'/%3E%3C/svg%3E%0A\")",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: theme.palette.colour.primaryBlue,
    },
  },
}));

const StyledCheckbox = (props: CheckboxProps): React.ReactElement => {
  const classes = useStyles();

  return (
    <Checkbox
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon, "checkbox-icon")} />}
      icon={<span className={clsx(classes.icon, "checkbox-icon")} />}
      inputProps={{ "aria-label": "checkbox" }}
      {...props}
    />
  );
};

export default StyledCheckbox;
